import {
  CLEAR_INDUSTRY_SELECTION,
  INDUSTRY_LOADED,
  RATE_INDUSTRY,
  SELECT_INDUSTRY_COMPARISON_LMI
} from '../../actions/industry'
import * as h2Api from '../../h2Api'

const initialState = {
  selectedProfile: null
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_INDUSTRY_SELECTION:
      return initialState

    case SELECT_INDUSTRY_COMPARISON_LMI:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: {
            ...state.selectedProfile,
            comparisonWages: p
          }
        }
      }

      return state

    case INDUSTRY_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: p
        }
      }

      return state

    case RATE_INDUSTRY:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: {
            ...state.selectedProfile,
            personalization: {
              ...state.selectedProfile.personalization,
              ...action.restCall.result
            }
          }
        }
      }

      return state

    default:
      return state
  }
}

export default reducers
